
import { useState } from 'react';
import { useEffect } from 'react';
import { Get_operatorsSetting } from '../../../../api/api';
import axios from 'axios';
import Loading from '../../../Loading'
import { post_TrafficPrice, Get_operators } from './../../../../api/api';
import { toast } from 'react-toastify';

const GetAllOp = () => {

     const [opTypeSelect, setOpTypeSelect] = useState(0)
     const [isLoading, setIsLoading] = useState(false)
     const [isLoadingForm, setIsLoadingForm] = useState(false)
     const [refreshData, setRefreshData] = useState(false)
     const [operators, setOperators] = useState([])
     const [operatorsType, setOperatorsType] = useState([])

     const handleSubmitForm = async (e) => {
          e.preventDefault()

          let producerPrice = e.target.producerPrice.value !== '' ? parseInt(e.target.producerPrice.value) : 0
          let publisherPrice = e.target.publisherPrice.value !== '' ? parseInt(e.target.publisherPrice.value) : 0
          let operatorTypes = parseInt(e.target.operatorTypes.value)

          try {
               setIsLoadingForm(true)
               const res = await axios.post(post_TrafficPrice, {
                    producerPrice: producerPrice,
                    publisherPrice: publisherPrice,
                    operatorType: operatorTypes
               })
               toast.success('نرخ محاسبه ترافیک بروز شد.')
               setRefreshData(!refreshData)
          } finally { setIsLoadingForm(false) }
     }

     const handleSelectTypeChange = e => {
          setOpTypeSelect(e.target.value)
     }


     useEffect(() => {
          const GET_OP = async () => {
               try {
                    setIsLoading(true)
                    const res = await axios.get(Get_operatorsSetting)
                    setOperators(res.data)
               } finally { setIsLoading(false) }
          }
          GET_OP()

          const GET_OPType = async () => {
               try {
                    const res = await axios.get(Get_operators)
                    setOperatorsType(res.data)
               } finally { }
          }
          GET_OPType()
     }, [refreshData])



     return (
          <div className="contentHolder pb-0">
               <div className="row">
                    <div className="col-12">
                         <div className="box_radios">

                              <div className="headHolder bordered">
                                   <p className="title">نرخ محاسبه ترافیک برای هر گیگابایت</p>
                                   {operators.length !== 0 && operators.map(i => i.operatorType.id == opTypeSelect && <span className='hidden-xs' style={{ fontSize: '13.5px', fontWeight: 300 }} key={i.operatorType.id}>آخرین تغییر : {i.regDate}</span>)}
                              </div>

                              <div className="requestSettingForm" style={{ padding: '20px' }}>
                                   {isLoading ? <Loading styles={'mini'} /> : (

                                        <form onSubmit={handleSubmitForm}>

                                             <p>
                                                  <span style={{ fontWeight: 300, display: 'block', marginBottom: '1rem' }}>اپراتور :</span>
                                                  <select name="operatorTypes" id="operatorTypes" defaultValue={opTypeSelect} onChange={handleSelectTypeChange}>
                                                       {operatorsType && operatorsType.map(op => (
                                                            <option key={op.id} value={op.id}>{op.title}</option>
                                                       ))}
                                                  </select>
                                             </p>


                                             {operators.length !== 0 ? operators.map(op => (
                                                  op.operatorType.id === parseInt(opTypeSelect) && (
                                                       <div key={op.operatorType.id}>
                                                            <p>
                                                                 <span style={{ fontWeight: 300 }}>ناشر :</span>
                                                                 <input type="number" defaultValue={op.producerPrice} name={'producerPrice'} placeholder='مبلغ را به تومان وارد نمایید' />
                                                            </p>

                                                            <p>
                                                                 <span style={{ fontWeight: 300 }}>تولید کننده :</span>
                                                                 <input type="number" defaultValue={op.publisherPrice} name={'publisherPrice'} placeholder='مبلغ را به تومان وارد نمایید' />
                                                            </p>
                                                       </div>
                                                  )
                                             ))
                                                  :
                                                  (
                                                       <div>
                                                            <p>
                                                                 <span style={{ fontWeight: 300 }}>ناشر :</span>
                                                                 <input type="number" defaultValue={''} name={'producerPrice'} placeholder='مبلغ را به تومان وارد نمایید' />
                                                            </p>

                                                            <p>
                                                                 <span style={{ fontWeight: 300 }}>تولید کننده :</span>
                                                                 <input type="number" defaultValue={''} name={'publisherPrice'} placeholder='مبلغ را به تومان وارد نمایید' />
                                                            </p>
                                                       </div>
                                                  )}



                                             <br />
                                             {isLoadingForm
                                                  ?
                                                  <p><button type="button" className='disabled' style={{ padding: '1rem 2rem' }}> لطفا صبر کنید...</button></p>
                                                  :
                                                  <p><input type="submit" value="ذخیره" /></p>
                                             }
                                        </form>
                                   )}

                              </div>

                         </div>
                    </div>
               </div>
          </div>
     )
}


export default GetAllOp